var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcConnectorBusy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.42096 34.9191C5.3087 35.0175 5.19511 35.1199 5.07751 35.2183C4.51022 35.6942 3.91354 36.1386 3.38167 36.6512C2.61259 37.3928 2.35868 38.3204 2.61593 39.3638C2.90793 40.5484 3.94561 41.4178 5.1597 41.4506C6.49606 41.4867 7.83309 41.4733 9.17012 41.4733C18.4545 41.4746 27.7395 41.4733 37.0239 41.474C37.6186 41.474 38.2113 41.4358 38.7672 41.215C40.447 40.5477 41.4346 39.1891 41.484 37.3319C41.5201 35.9706 41.4934 34.6079 41.4934 33.246C41.4934 24.4986 41.4914 15.7506 41.4967 7.00324C41.4967 6.29716 41.3985 5.61517 41.1092 4.97267C40.7784 4.23982 40.2666 3.65756 39.5938 3.20848C38.8267 2.69716 37.9761 2.52582 37.076 2.52582C27.1315 2.52582 17.1863 2.52649 7.24175 2.52582C6.62034 2.52582 6.00027 2.53586 5.40492 2.73664C4.01911 3.20446 3.08433 4.12337 2.69611 5.54691C2.58252 5.96319 2.51704 6.40625 2.51637 6.83659C2.50635 15.337 2.50769 23.8374 2.5137 32.3378C2.5137 32.5827 2.4549 32.7467 2.25511 32.9046C1.61165 33.4133 0.986905 33.9474 0.356142 34.4721C0.255915 34.5557 0.161033 34.6461 0.0340783 34.7599C0.0220511 34.6608 0.00534654 34.5865 0.00534654 34.5129C0.003342 32.8578 0.00267381 31.2027 0.00200563 29.5469C0.00200563 21.9949 0.00467836 14.4428 1.08925e-06 6.8908C-0.000667092 5.5188 0.306028 4.23982 1.0584 3.08199C1.83884 1.88065 2.89657 1.02264 4.22157 0.47652C5.11025 0.109091 6.03501 0.00200781 6.98183 0.00200781C17.0587 0.00133854 27.1355 0.00334635 37.2123 0C38.6496 0 39.9666 0.384161 41.1426 1.20803C42.1997 1.94891 42.9781 2.92404 43.4886 4.11735C43.8474 4.95594 43.9984 5.83135 43.9984 6.73486C44.0004 16.9078 44.0004 27.0807 43.9991 37.2536C43.9991 39.5431 43.0329 41.3528 41.2281 42.7215C40.4651 43.2997 39.5937 43.6759 38.6576 43.8713C38.2507 43.9563 37.8264 43.9944 37.4101 43.9944C26.7359 44.0011 16.0624 44.0005 5.38821 43.9991C3.79728 43.9991 2.45624 43.3948 1.3798 42.2389C0.577978 41.3783 0.132969 40.3402 0.0300692 39.1583C-0.106908 37.5808 0.353469 36.2021 1.41922 35.0436C1.79741 34.6327 2.25645 34.2947 2.68408 33.93C3.02018 33.6428 3.36697 33.3685 3.7044 33.0833C3.79794 33.0044 3.86409 33.001 3.94494 33.1001C4.42537 33.6864 4.90913 34.2693 5.39089 34.8536C5.40091 34.8663 5.40492 34.8837 5.42029 34.9185L5.42096 34.9191Z",
    fill: "url(#paint0_linear_1570_47600)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8467 26.0754C31.7404 26.7112 31.0963 27.236 30.4502 27.24C29.9049 27.244 29.3597 27.234 28.8151 27.242C28.1884 27.2514 27.7247 26.9662 27.3959 26.4549C27.2255 26.1906 27.0886 25.9041 26.9489 25.621C26.8834 25.4885 26.7966 25.4423 26.6522 25.443C25.3727 25.447 24.0931 25.4416 22.8142 25.4497C22.6852 25.4503 22.5376 25.4912 22.4307 25.5614C21.0616 26.4643 19.6991 27.3778 18.3334 28.286C16.9055 29.2357 15.4749 30.1807 14.0463 31.1304C13.3107 31.6197 12.5783 32.1136 11.844 32.6042C11.2433 33.0057 10.5157 32.9201 10.0473 32.3652C9.28821 31.4657 8.54653 30.5522 7.79482 29.6467C7.60773 29.4218 7.41129 29.2043 7.21885 28.9841C6.71036 28.4032 6.70569 27.681 7.24023 27.1222C7.69192 26.6497 8.17502 26.2073 8.64408 25.7508C9.84614 24.583 14.5214 20.0554 15.6586 18.9604C16.3489 18.2959 17.0224 17.6112 17.738 16.974C18.6655 16.1488 19.7359 15.5445 20.9146 15.1623C21.9155 14.8377 22.9478 14.6523 24.0082 14.6537C26.091 14.657 28.1737 14.6577 30.2564 14.6523C30.6373 14.6517 30.9827 14.736 31.2867 14.9682C31.6215 15.2239 31.832 15.5552 31.8747 15.9782C31.8995 16.2238 31.9008 25.7529 31.8473 26.0734L31.8467 26.0754Z",
    fill: "url(#paint1_linear_1570_47600)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8906 25.4449V15.7265C32.8906 15.7265 35.3008 15.7245 36.4367 15.7265C37.1483 15.7278 37.751 16.2023 37.8846 16.8636C37.9073 16.9753 37.912 17.0918 37.912 17.2062C37.912 19.4925 37.9 21.7787 37.916 24.0649C37.9207 24.7067 37.3554 25.4222 36.5543 25.4376C35.3502 25.461 32.8913 25.4443 32.8913 25.4443L32.8906 25.4449Z",
    fill: "url(#paint2_linear_1570_47600)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8764 6.44873C13.2289 8.66402 11.9467 12.8429 11.9467 12.8429C11.9467 12.8429 16.1649 12.8429 15.9237 12.8429C13.4795 15.6719 10.4192 18.5498 7.97499 21.3788C7.96429 21.3734 7.95427 21.3688 7.94358 21.3634C8.70063 19.0417 9.91405 14.9933 9.91405 14.9933H6.4502C8.93516 12.1188 13.853 6.43066 13.853 6.43066C13.853 6.43066 13.869 6.44271 13.877 6.44873H13.8764Z",
    fill: "url(#paint3_linear_1570_47600)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54899 33.2802C9.54899 33.2802 8.86745 33.655 8.53536 33.833C8.10171 34.0659 7.65537 34.2774 7.23374 34.5304C6.7894 34.7961 6.38448 34.6187 6.13058 34.3176C5.59469 33.6817 5.06884 33.0379 4.53897 32.3974C4.17214 31.9544 4.19619 31.4946 4.59242 31.0716C5.10959 30.5188 5.62209 29.9619 6.12723 29.3978C6.2308 29.282 6.28827 29.2867 6.37847 29.3964C6.97917 30.1279 8.81332 32.3459 9.1247 32.7287C9.26167 32.8974 9.54966 33.2809 9.54966 33.2809L9.54899 33.2802Z",
    fill: "url(#paint4_linear_1570_47600)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1570_47600",
    x1: 22,
    y1: 0,
    x2: 22,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7676"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1570_47600",
    x1: 19.3648,
    y1: 14.6523,
    x2: 19.3648,
    y2: 32.8537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7676"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1570_47600",
    x1: 35.4033,
    y1: 15.7256,
    x2: 35.4033,
    y2: 25.4501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7676"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1570_47600",
    x1: 11.1919,
    y1: 6.43066,
    x2: 11.1919,
    y2: 21.3788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7676"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1570_47600",
    x1: 6.91423,
    y1: 29.3125,
    x2: 6.91423,
    y2: 34.6603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7676"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcConnectorBusy);
export default __webpack_public_path__ + "static/media/ic_connector_busy.502260b90b5bd2899b6667b527a39b83.svg";
export { ForwardRef as ReactComponent };